export default __webpack_public_path__ + "static/media/4.c31d9942.gif";